module.exports = __webpack_public_path__ + "img/kr.472436a2.svg";